// extracted by mini-css-extract-plugin
module.exports = {"home":"index-module--home--UKgeX","h3":"index-module--h3--ctz-L","h2":"index-module--h2--3rcIE"};